import { styled } from '@styles';
import { Container } from '@components/templates/Container';
import { prismicRichText } from '@styles/utils';

export const Wrapper = styled(Container)`
  ${prismicRichText}
`;
